
.product-card {
  display: grid;
  grid-template-columns: 1fr;
  justify-content: space-between;
  gap: 16px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0px 0px 10px 0px #E4E4E4;
  background-color: white;
  height:337px;
}
.product-footer{
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding: 0px  12px 16px 12px;
}

.product-image {
  width: 100%;
  height: 160px !important;
  object-fit: cover;
  transition: all .3s ease-in-out;
  cursor: pointer;
}

.image-container{
  overflow: hidden;
}

 .group:hover .product-image{
   transform: scale(1.05);
 }
 .card-body{
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: space-between;
  padding-bottom: 16px;
 }
 .cart-details{
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: auto;
 }
 .product-title{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  width: 100%;
  font-weight: 700;
  text-align: right;
  color: #313535;
 }

.rate-container{
  display: flex;
  align-items: center;
  gap: 6px;
}
.star-container{
  display: flex;
  align-items: center;
  gap: 4px;
}
.rate{
  color: #6D7676;
  font-size: 12px;
}

.price-container > div{
  display: flex;
  align-items: center;
  gap: 4px;
}
.price{
  color: #929A9A;
  font-size: 14px;
  text-decoration: line-through;
  text-wrap: nowrap;

}
.discount{
   background-color: var(--mainColor);
   color: white;
   font-size: 12px;
   display: flex;
   align-items: center;
   position: absolute;
   top: 10px;
   right: 10px;
   padding-right: 8px;
   padding-left: 8px;
   justify-content: center;
   width: max-content;
   height: 20px;
}
.card-footer{
  display: flex;
  justify-content: center;
  margin: auto;
}
.cart-button {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:8px;
  max-height: 40px;
  text-wrap: nowrap;
  border-radius: var(--mainRadius);
  border: 1px solid var(--mainColor);
  color: var(--mainColor);
     width: 100%;
  cursor: pointer;
}
.price-discount{
   font-weight: 700;
   font-size: 16px;
   text-wrap: nowrap;
  }
  @media (min-width: 320px) {
    .card-footer{
      display: flex;
      justify-content: center;
      margin: 0px 12px;
    }
    .cart-details{
      margin: 0px 12px 0px 12px;
    }
  }
@media (min-width: 768px) {
  .md\:w-\[168px\] {
      width: 168px;
  }
  .price-discount{
    font-size: 18px;
  }
  .cart-button{
    width: 100%;
  }
  .card-footer{
    display: flex;
    justify-content: center;
    margin: 0px 12px;
  }
  .cart-details{
    margin: 0px 12px 0px 12px;
  }
}
.price-container{
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.empty-image{
  width: 100%;
  min-height: 160px;
  height: 100%;
  display: flex;
  background-color: #E4E4E4;
}
.social-container{
   display: grid;
   grid-template-columns: repeat(2, minmax(0, 1fr));
   gap: 8px;
   width: 100%;
}
/* .cart-button-social{
   height: 40px;
   display: flex;
   padding: 0px 12px;
   flex : 1 1 0%;
   text-wrap: nowrap;
   gap: 8px;
   align-items: center;
   justify-content: center;
   border-radius: var(--mainRadius);
   border: 1px solid var(--mainColor);
   color: var(--mainColor);
   width: 100%;
   cursor: pointer;
} */

.cart-button-social-whatsapp{
   display: flex;
   align-items: center;
   justify-content: center;
   color: white;
   background: #20B038;
   border: 0px;
   height: 32px;
   padding: 0px 12px;
   text-wrap: nowrap;
   gap: 8px;
}
.text-price-without-discount{
  font-weight: 700;
  color: var(--mainColor); 
  font-size: 18px;
}

.cart-button-social-phone{
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: #2899F3;
  border: 0px;
  height: 32px;
  padding: 0px 12px;
  text-wrap: nowrap;
  gap: 8px;
}

.private-price-title{
  font-size: 14px;
  color: #6D7676;
}

.private-price-container{
  display: grid;
  gap: 1px;
}